import { useMutation } from 'react-query';
import { ReservationArgs } from '~/lib/data-contract';
import { addReservation } from '../../Reserve/service/add-reservation';
import { useReservationPaths } from './useReservationPaths';

export const useReservation = () => {
    const { add } = useReservationPaths();

    const { isLoading, isSuccess, mutateAsync: createReservation } = useMutation<
        unknown,
        Response,
        ReservationArgs
    >((fields) => addReservation(add, fields));

    return {
        // status,
        isLoading,
        isSuccess,
        createReservation,
    };
};
